import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";
import { Dropdown } from "primereact/dropdown";
import React, { Suspense, useContext, useEffect, useState } from "react";
import { Chart } from 'primereact/chart';
import { getManagerList, getProjectClient, getProjectTimeSheet, getTimeSheet, getTimeSheetSummary } from "./TimeSheetServices";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import dayjs from "dayjs";
import { TostMsg } from "../../../App";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { InputSwitch } from 'primereact/inputswitch';


const TimesheetSummery = () => {
  const [BillableProjectsData, setBillableProjectsData] = useState({});
  const [nonBillableProjectsData, setNonBillableProjectsData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  // const [filterGroupBy, setFilterGroupBy] = useState({ type3: 'By Project & tasks', type1: 1, type2: 2 });
  const [filterGroupBy, setFilterGroupBy] = useState({ text: 'By Project & Tasks', value: 3 });
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [range, setRange] = useState({
    start: currentDate.startOf("month").format("DD MMM YYYY"),
    end: currentDate.endOf("month").format("DD MMM YYYY"),
  });
  const [timesheetList, setTimesheetList] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [projectTypeList, setProjectTypeList] = useState([]);
  const [timesheetSummery, setTimesheetSummery] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [projectClientList, setProjectClientList] = useState([]);
  const [selectedProjectTypeId, setSelectedProjectTypeId] = useState(0);
  const [selectedProjectId, setSelectedProjectId] = useState(0);
  const [selectedProjectClientId, setSelectedProjectClientId] = useState(0);
  const [selectedValue, setSelectedValue] = useState(4);
  const [globalFilter, setGlobalFilter] = useState('');
  const [managerList, setManagerList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedNodeKeys, setSelectedNodeKeys] = useState({});
  const [checked1, setChecked1] = useState(true);
  // const options = [
  //   { label: 'Last Month', value: 4 },
  //   { label: 'One', value: 1 },
  //   { label: 'Two', value: 2 },
  //   { label: 'Three', value: 3 }
  // ];
  const [StatusId, setStatusId] = useState(0);

  useEffect(() => {
    setStatusId(104);
    GetManagerList();
    GetTimeSheet(filterGroupBy.value, checked1);
    GetTimeSheetSummary(filterGroupBy.value, checked1);
  }, [StatusId, selectedProjectTypeId, selectedProjectId, selectedProjectClientId, currentDate, range, checked1])

  useEffect(() => {
    getMasterTypeList();
    GetProjectTimeSheet();
    GetProjectClient();
  }, []);

  const handlePresetMontChange = (value) => {
    setSelectedValue(value);
    let end;
    let start;
    const monthsBack = Number(value);
    if (!monthsBack) return;
    if (value == 4) {
      start = currentDate.startOf("month").format("DD MMM YYYY");
      end = currentDate.endOf("month").format("DD MMM YYYY");
    } else {
      end = currentDate.add(0, "month").endOf("month").format("DD MMM YYYY");
      start = currentDate.add(-value, "month").startOf("month").format("DD MMM YYYY");
    }
    setRange({
      start: start,
      end: end
    });
  };

  const handlePrevMonth = () => {
    const newDate = currentDate.subtract(1, "month");
    setCurrentDate(newDate);

    setRange({
      start: newDate.startOf("month").format("DD MMM YYYY"),
      end: newDate.endOf("month").format("DD MMM YYYY"),
    });
  };

  const handleNextMonth = () => {
    const newDate = currentDate.add(1, "month");
    setCurrentDate(newDate);

    setRange({
      start: newDate.startOf("month").format("DD MMM YYYY"),
      end: newDate.endOf("month").format("DD MMM YYYY"),
    });
  };


  async function GetTimeSheet(GroupBy, checked1) {
    setIsloading(true);
    let EmpId = 0;
    let HierarchyTypeId = 0;
    if (checked1) {
      HierarchyTypeId = 0;
      EmpId = userDetails?.EmpId;
    } else {
      EmpId = 0;
      HierarchyTypeId = 3;
    }
    const body = {
      EmpId: EmpId,
      ClientId: selectedProjectClientId ?? 0,
      ProjectId: selectedProjectId ?? 0,
      StatusId: StatusId,
      GroupBy: GroupBy,
      HierarchyTypeId: HierarchyTypeId,
      FetchType: 1,
      BillableType: selectedProjectTypeId ?? 0,
      StartDate: String(range?.start),
      EndDate: String(range?.end),
    };

    try {
      const response = await getTimeSheet(body);
      const apiData = response?.Data;
      if (!apiData?.TimeSheetResponses?.length) {
        setTimesheetList([]);
        return;
      }

      // FIX: Map over groups
      const nodes = apiData.TimeSheetResponses.map((group, index) => {
        const groupKey = `${index + 1}`;
        const totalBillable = group.BillableHours ?? 0;
        const submittedHours = group.Hours ?? 0;
        return {
          key: groupKey,
          data: {
            id: group.Id,
            user: group.GroupByName,
            byDate: "",
            billableHours: totalBillable.toFixed(2),
            submittedHours: submittedHours.toFixed(2),
            pending: group.PendingHours?.toFixed(2) ?? "0.00",
            approved: group.ApprovedHours?.toFixed(2) ?? "0.00",
            rejected: group.RejectedHours?.toFixed(2) ?? "0.00",
            //  status: group.StatusName ?? 'N/A',
          },
          children: group.TimeSheets.map((t, tIndex) => ({
            key: `${groupKey}-${tIndex + 1}`,
            data: {
              id: t.Id,
              user: t.Task,
              byDate: new Date(t.TimeSheetDate).toLocaleDateString(),
              billableHours: t.BillableHours?.toFixed(2),
              submittedHours: t.Hours?.toFixed(2),
              pending: t.PendingHours ?? 0,
              approved: t.ApprovedHours ?? 0,
              rejected: t.RejectedHours ?? 0,
              status: t.StatusName ?? 'N/A',
              // ✅ FIX: this was missing, so the project-name badge under each
              // task (used when grouping "By Date & Tasks" / "By Users & Tasks")
              // never had anything to read and silently rendered nothing.
              ProjectName: t.ProjectName ?? '',
            },
          }))
        };
      });
      setTimesheetList(nodes);
    } catch (err) {
      toster.current.error("Failed to load timesheet");
    } finally {
      setIsloading(false);
    }
  }


  async function getMasterTypeList() {
    const params = { organisationId: userDetails?.OrgId, masterType: "ProjectType" };
    try {
      const data = await GetMasterTypeData(params);
      setProjectTypeList(data?.Data || []);
    } catch (error) {
      toster.current.error("Failed to load projects");
    }
  }

  async function GetTimeSheetSummary(GroupBy, checked1) {
    let EmpId = 0;
    let HierarchyTypeId = 0;
    if (checked1) {
      EmpId = userDetails?.EmpId;
      HierarchyTypeId = 0;
    } else {
      EmpId = 0;
      HierarchyTypeId = 3;
    }
    const params = {
      EmpId: EmpId,//userDetails?.EmpId,
      ClientId: selectedProjectClientId ?? 0,
      ProjectId: selectedProjectId ?? 0,
      StatusId: StatusId,
      GroupBy: GroupBy,
      HierarchyTypeId: HierarchyTypeId,
      FetchType: 1,
      BillableType: selectedProjectTypeId ?? 0,
      StartDate: String(range?.start),
      EndDate: String(range?.end),
    };
    try {
      const data = await getTimeSheetSummary(params);
      setTimesheetSummery(data?.Data || []);
    } catch (error) {
      toster.current.error("Failed to load projects");
    }
  }

  async function GetProjectTimeSheet() {
    const params = {
      Id: 0,
      Guid: ""
    };
    try {
      const data = await getProjectTimeSheet(params);
      setProjectList(data?.Data || []);
    } catch (error) {
      // toster.current.error("Failed to load projects");
    }
  }

  async function GetProjectClient() {
    try {
      const data = await getProjectClient();
      setProjectClientList(data?.Data || []);
    } catch (error) {
      // toster.current.error("Failed to load projects");
    }
  }


  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    let BillableProjects = timesheetSummery?.BillableProjects?.map((item) => item?.Hours);
    let NonBillableProjects = timesheetSummery?.NonBillableProjects?.map((item) => item?.Hours);
    const data = {
      labels: timesheetSummery?.BillableProjects?.map((item) => item?.ProjectName),//['A', 'B', 'C'],
      datasets: [
        {
          data: BillableProjects,//[300, 50, 100],
          backgroundColor: [
            documentStyle.getPropertyValue('--blue-500'),
            documentStyle.getPropertyValue('--yellow-500'),
            documentStyle.getPropertyValue('--green-500')
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--blue-400'),
            documentStyle.getPropertyValue('--yellow-400'),
            documentStyle.getPropertyValue('--green-400')
          ]
        }
      ]
    };
    const NonBillableData = {
      labels: timesheetSummery?.NonBillableProjects?.map((item) => item?.ProjectName),
      datasets: [
        {
          data: NonBillableProjects,//[300, 50, 100],
          backgroundColor: [
            documentStyle.getPropertyValue('--blue-500'),
            documentStyle.getPropertyValue('--yellow-500'),
            documentStyle.getPropertyValue('--green-500')
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--blue-400'),
            documentStyle.getPropertyValue('--yellow-400'),
            documentStyle.getPropertyValue('--green-400')
          ]
        }
      ]
    };
    const options = {
      cutout: '60%'
    };

    setBillableProjectsData(data);
    setNonBillableProjectsData(NonBillableData);
    setChartOptions(options);
  }, [timesheetSummery]);

  const userFilterChange = (event) => {
    let type = event.target.value
    GetTimeSheet(type);
    if (type == 3) {
      setFilterGroupBy({ text: 'By Project & Tasks', value: 3 })
    } else if (type == 2) {
      setFilterGroupBy({ text: 'By Date & Tasks', value: 2 })
    } else {
      setFilterGroupBy({ text: 'By User & Tasks', value: 1 })
    }
  }

  const getHeader = () => {
    return (
      <div className="flex justify-content-end">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
        </IconField>
      </div>
    );
  };

  let header = getHeader();

  const flattenTreeTableData = (nodes) => {
    let rows = [];

    nodes.forEach(node => {
      if (node.data) {
        rows.push(node.data);
      }

      if (node.children && node.children.length) {
        node.children.forEach(child => {
          rows.push(child.data);
        });
      }
    });

    return rows;
  };

  const downloadExcel = () => {
    const flatData = flattenTreeTableData(timesheetList);

    const worksheet = XLSX.utils.json_to_sheet(
      flatData.map(item => ({
        User: item.user,
        "Total Hours": item.submittedHours,
        "Billable Hours": item.billableHours,
        "Pending Hours": item.pending,
        "Rejected Hours": item.rejected,
        "Approved Hours": item.approved,
        Status: item.status
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    saveAs(
      new Blob([excelBuffer], { type: "application/octet-stream" }),
      "Reports.xlsx"
    );
  };

    const ChangeStatus = async (rowData, statusId) => {
    const timesheetId = rowData.data.id;
    // await bulkStatusUpdate([timesheetId], statusId);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();

    const flatData = flattenTreeTableData(timesheetList);

    const tableColumn = [
      "User",
      "Total Hours",
      "Billable Hours",
      "Pending",
      "Rejected",
      "Approved",
      "Status"
    ];

    const tableRows = flatData.map(item => ([
      item.user,
      item.submittedHours,
      item.billableHours,
      item.pending,
      item.rejected,
      item.approved,
      item.status
    ]));

    doc.text("Timesheet Report", 14, 15);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20
    });

    doc.save("Reports.pdf");
  };


  async function GetManagerList() {
    try {
      const response = await getManagerList();
      setManagerList(response?.Data);
    }
    catch (err) {

    }
  }



  const managerOptionTemplate = (option) => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={option.ProfileImage}
          alt={option.ManagerName}
          style={{ width: "35px", height: "35px", borderRadius: "50%" }}
        />
        <div>
          <div>{option.ManagerName}  ({option.ManagerId})</div>
          <small style={{ color: "#777" }}>{option.UserName}</small>
        </div>
      </div>
    );
  };

  const handleSelectionChange = (e) => {
    setSelectedNodeKeys(filterSelectionKeys(e.value));
  };

  // Selected value UI
  const selectedManagerTemplate = (option) => {
    if (option) {
      return managerOptionTemplate(option);
    }
    return <span>Select Manager</span>;
  };

  const rowClassName = (node) => {
    const statusId = Number(node?.data?.statusId ?? node?.data?.TimeSheetStatusId ?? node?.data?.StatusId ?? 0);

    if (statusId === 103) return 'row-status-103';
    if (statusId === 104) return 'row-status-104';

    if (node.data?.status === "Approved") return 'row-approved';
    if (node.data?.status === "Rejected") return 'row-rejected';

    const hasApprovedChild = node.children?.some(child => child.data?.status === "Approved" || Number(child.data?.statusId) === 103);
    const hasRejectedChild = node.children?.some(child => child.data?.status === "Rejected" || Number(child.data?.statusId) === 104);

    if (hasApprovedChild) return 'row-approved';
    if (hasRejectedChild) return 'row-rejected';

    return ''; // default
  };

  const isRowSelectable = (node) => {
    if (!node || !node.data) {
      return false;
    }

    const statusId = Number(node.data?.statusId ?? node.data?.TimeSheetStatusId ?? node.data?.StatusId ?? 0);
    const statusText = String(node.data?.status || "").toLowerCase();
    const isRejectedOrApproved = statusId === 103 || statusId === 104 || statusText === "approved" || statusText === "rejected";
    return !isRejectedOrApproved;
  };

    const findNodeByKey = (key, nodes = timesheetList) => {
    for (const node of nodes) {
      if (String(node.key) === String(key)) return node;
      if (node.children) {
        const child = findNodeByKey(key, node.children);
        if (child) return child;
      }
    }
    return null;
  };


  const filterSelectionKeys = (selectionKeys) => {
    if (!selectionKeys || typeof selectionKeys !== "object") return {};
    return Object.keys(selectionKeys).reduce((acc, key) => {
      const node = findNodeByKey(key);
      if (node && isRowSelectable(node)) {
        acc[key] = selectionKeys[key];
      }
      return acc;
    }, {});
  };


  return (
    <div>
      <div className="container-fluid   position-relative">
        <div className="row team-directories g-3">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-end justify-content-between">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Timesheet Summary  </h2>
                <p className="mb-0">Manage your tasks, projects, and workspaces in one place.</p>


              </div>
              <div className="rightside-tabs">
                <button class="primary-blue-btn">
                  <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                  Download
                </button>

              </div>

            </div>
          </div>
          <div className="timesheet-range">
            <div className="d-flex align-items-center flex-wrap">

              <div className="timeclick-box me-2 week-nav">


                <button type="button" className="btn btn-default nav-btn" onClick={handlePrevMonth}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-left"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                    />
                  </svg>
                </button>
                <span className="week-range">   {currentDate.format("MMMM YYYY")} </span>
                <button type="button" className="btn btn-default nav-btn" onClick={handleNextMonth}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                    />
                  </svg>
                </button>

              </div>
              <div className="timebox-edit-column  d-flex align-items-center col-lg-auto">
                <span className="me-1"><svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M9 17H5a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v5"></path><path d="M13 21l2-2 4 4M17 17l4 4"></path></svg></span>
                <span>
                  <select className="" aria-label="Default select example" onChange={(event) => userFilterChange(event)}>
                    <option selected value={3}>By Project & Tasks</option>
                    <option value={2}>By Date & Tasks</option>
                    <option value={1}>By Users & Tasks </option>

                  </select>
                </span>
              </div>
              <div className="timebox-edit-column d-flex align-items-center">
                <i class="fa fa-users" aria-hidden="true"></i>
                <select class="" aria-label="Default select example" onChange={(event) => setSelectedProjectTypeId(event?.target?.value)}>
                  <option selected value={0}>Project Type</option>
                  {projectTypeList?.map((item) => (
                    <option value={item?.Id}>{item?.Name}</option>
                  ))}



                </select>
              </div>
              {/* <div className="timebox-edit-column d-flex align-items-center">
                <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"></circle><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"></path></svg> */}
              {/* <span className="ms-2"> Manager</span> */}
              {/* <select class="" aria-label="Default select example" onChange={(event) => setSelectedProjectId(event?.target?.value)}>
                  <option selected value={0}>Select Manager</option>
                  {managerList?.map((item) => (
                    <option value={item?.Id}>{item.ManagerName}</option>
                  ))}
                </select> */}
              {/* <Dropdown
                  value={selectedManager}
                  options={managerList}
                  onChange={(e) => setSelectedManager(e.value)}
                  optionLabel="ManagerName"
                  placeholder="Select Manager"
                  itemTemplate={managerOptionTemplate}
                  valueTemplate={selectedManagerTemplate}
                  style={{ width: "300px" }}
                />              */}

              {/* </div> */}


              <div className="timebox-edit-column  d-flex align-items-center">
                <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"></rect><path d="M16 3H8"></path></svg>
                <select class="" aria-label="Default select example" onChange={(event) => setSelectedProjectClientId(event?.target?.value)}>
                  <option selected value={0}>Select Client</option>
                  {projectClientList?.map((item) => (
                    <option value={item?.Id}>{item?.ClientName}</option>
                  ))}
                </select>
              </div>
              <div className="timebox-edit-column  d-flex align-items-center">
                <i class="fa fa-suitcase" aria-hidden="true"></i>
                <select class="" aria-label="Default select example" onChange={(event) => setSelectedProjectId(event?.target?.value)}>
                  <option selected value={0}>Select Projects</option>
                  {projectList?.map((item) => (
                    <option value={item?.Id}>{item.Name}</option>
                  ))}
                </select>
              </div>
              <div className=" d-flex align-items-center">
                <span className="me-1"> {checked1 ? 'Mine' : 'Team'}:</span>  <InputSwitch checked={checked1} onChange={(e) => setChecked1(e.value)} />
              </div>

            </div>

          </div>

          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="row justify-content-center ">
                <div className="col-lg-7">
                  <div className="timesheet-area">


                    <div class="stats-grid-timesheet">
                      <div class="stat-card-timesheet c1-bx">
                        <div class="stat-icon">
                          <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 3"></path></svg>
                        </div>
                        <div class="stat-label">Total Hours</div>
                        <div class="stat-value">{timesheetSummery?.TotalHours} hrs</div>
                        <div class="stat-meta">
                          <span class="delta up">↑ 1.5 hrs</span> vs Last month (120 hrs)
                        </div>
                      </div>

                      <div class="stat-card-timesheet c2-bx">
                        <div class="stat-icon">
                          <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        </div>
                        <div class="stat-label">Approved Hours</div>
                        <div class="stat-value">{timesheetSummery?.ApprovedHours} hrs</div>
                        <div class="stat-meta">
                          <span class="delta up">↑ 1.5 hrs</span> vs Last month (12 hrs)
                        </div>
                      </div>

                      <div class="stat-card-timesheet c3-bx">
                        <div class="stat-icon">
                          <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                        </div>
                        <div class="stat-label">Pending Hours</div>
                        <div class="stat-value">{timesheetSummery?.PendingHours} hrs</div>
                        <div class="stat-meta">
                          <span class="delta up">↑ 1.2 hrs</span> vs Last month (0 hrs)
                        </div>
                      </div>

                      <div class="stat-card-timesheet c4-bx">
                        <div class="stat-icon">
                          <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"></rect><path d="M16 3H8"></path><path d="M12 12v4M10 14h4"></path></svg>
                        </div>
                        <div class="stat-label">Billable Hours</div>
                        <div class="stat-value">{timesheetSummery?.BillableHours} hrs</div>
                        <div class="stat-meta">
                          <span class="delta neutral">→ 1 hr</span> vs Last month (1 hr)
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="col-lg-12">
                    <div className="row ">
                      {BillableProjectsData?.labels?.length ? (
                        <div className="col-md-6">
                          <h6 className="font-w500 text-center">Billable Project</h6>
                          <div className=" d-flex justify-content-center">
                            <div className="">
                              <Chart type="doughnut" data={BillableProjectsData} options={chartOptions} className="w-full md:w-20rem" />
                            </div>
                          </div>
                        </div>) : <></>}
                      {nonBillableProjectsData?.labels?.length ? (<div className="col-md-6">
                        <h6 className="font-w500 text-center">Non Billable Project</h6>
                        <div className=" d-flex justify-content-center">
                          <div className="">
                            <Chart type="doughnut" data={nonBillableProjectsData} options={chartOptions} className="w-full md:w-20rem" />
                          </div>
                        </div>
                      </div>) : <></>}
                    </div>
                  </div>

                </div>

                <div className="setting-detail-list mt-3">
                  <div className="detail award-detail">


                    <div className="col-md-12 column  border-0">
                      <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between border-0 reports-top">
                          <h4 className="card-title reports-title">
                            <div className="reports-title-bar"></div>
                            Reports</h4>
                          <div className="d-flex">
                            <div class="dropdown documents-dropdown">
                              <button
                                className="btn btn-purple me-2"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download me-1" viewBox="0 0 16 16">
                                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                </svg> Download
                              </button>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a class="dropdown-item" href="#" onClick={downloadPDF}>
                                    PDF Report
                                  </a>
                                </li>
                                <li>
                                  <a class="dropdown-item" href="#" onClick={downloadExcel} >
                                    Excel Report
                                  </a>
                                </li>

                              </ul>
                            </div>
                            <input
                              name="requestTitle"
                              className="form-control search-grpname me-2"

                              placeholder="Search"
                            />
                          </div>
                          {/* <div className="dropdown"> */}
                        </div>
                        <div className="card-body p-0">
                          <div className="table-responsive timesheet-summery">
                            <TreeTable
                              value={timesheetList}
                              rowClassName={rowClassName}
                              tableStyle={{ minWidth: "60rem" }}
                              selectionMode="checkbox"
                              selectionKeys={selectedNodeKeys}
                              onSelectionChange={handleSelectionChange}
                              rowSelectable={isRowSelectable}
                              className="table table-bordered table-hover treeapproval-table"
                            >
                              {/* <Column field="user" header={filterGroupBy?.text} expander  /> */}
                              <Column className="timetable-name-bx"
                                  
                                field="user"
                                header={filterGroupBy?.text}
                                expander
                                body={
                                  filterGroupBy?.value !== 3
                                    ? (rowData) => {
                                      const isChild = !rowData.children;

                                      return (
                                        <div>
                                          <div>{rowData.data.user}</div>

                                          {isChild && rowData.data.ProjectName && (
                                            <small
                                              style={{
                                                background: "#e9d8fd",
                                                color: "#6b21a8",
                                                padding: "2px 8px",
                                                borderRadius: "6px",
                                                fontWeight: "600",
                                                display: "inline-block",
                                                marginTop: "2px",
                                              }}
                                            >
                                              {rowData.data.ProjectName}
                                            </small>
                                          )}
                                        </div>
                                      );
                                    }
                                    : undefined}
                              />
                              <Column field="submittedHours" header=" Submitted Hours" />
                              <Column field="billableHours" header="Billable Hours" />
                              <Column field="pending" header="Pending Hours" />
                              <Column field="rejected" header="	Rejected Hours" />
                              <Column field="approved" header="Approved Hours" />
                              <Column field="status" header="Status" />
                              <Column
                                header="Action"
                                body={(rowData) => {
                                  const isExpandable = !!rowData.children; // row has expander icon

                                  return (
                                    <div className="flex flex-wrap gap-2">
                                      {!isExpandable && (
                                        <>
                                          <button className="btn btn-purple me-2" onClick={() => ChangeStatus(rowData, 103)}>
                                            <i className="fa fa-thumbs-up"></i>
                                          </button>

                                          <button className="btn btn-danger" onClick={() => ChangeStatus(rowData, 104)}>
                                            <i className="fa fa-thumbs-down"></i>
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  );
                                }}
                              />
                            </TreeTable>
                            {/* <TreeTable value={timesheetList} globalFilter={globalFilter} tableStyle={{ minWidth: "60rem" }} className="table table-bordered  table-hover treeapproval-table" header={header} >
                             
                              <Column field="user" header={filterGroupBy.text} expander />
                              <Column field="submittedHours" header=" Total Hours" />
                              <Column field="billableHours" header="Billable Hours" />
                              <Column field="pending" header="Pending Hours" />
                              <Column field="rejected" header="	Rejected Hours" />
                              <Column field="approved" header="Approved Hours" />
                              <Column field="status" header="Status" />
                            </TreeTable> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : null}
    </div>
  )

}
export default TimesheetSummery